import { appSubmitPushNotificationToken } from 'data/app/actions';

import { getLogger } from 'app-components/utils/core';

import { getToken, onMessage } from 'firebase/messaging';
import { messaging } from 'swFirebaseInit';

import store from 'app-components/utils/redux-store';
import { getSwRegistration } from 'swMain';
import { navigate } from './NavigateSetter';

const log = getLogger('pushNotifications');

export const isPushNotificationsWaitingPermissions = () => Notification.permission === 'default';
export const isPushNotificationsAccepted = () => Notification.permission === 'granted';
export const isPushNotificationsDenied = () => Notification.permission === 'denied';

// TODO: Can we / should we, relate token to datasetId?
const customGetToken = async () => {
  try {
    await getToken({ serviceWorkerRegistration: getSwRegistration() })
      .then((token) => {
        store.dispatch(appSubmitPushNotificationToken(token));
      })
      .catch((e) => log.error('An error occurred while retrieving token. ', e));
  } catch (e) {
    log.error('An error occurred while retrieving token. ', e);
  }
};

export const initPushNotificationsIfAccepted = () => {
  if (!messaging || !isPushNotificationsAccepted()) {
    return;
  }

  customGetToken();
  // apparently onTokenRefresh was a no-op API that would never trigger, so it has been removed
};

export const enablePushNotifications = async () => {
  log.log('Requesting permission...');
  await Notification.requestPermission()
    .then((permission) => {
      if (permission === 'granted') {
        log.info('Notification permission granted.');
      }
    })
    .catch((e) => {
      log.info('Push Notification Permissions Denied. ', e);
      return false;
    });

  initPushNotificationsIfAccepted();
  return true;
};

if (messaging) {
  onMessage(messaging, (payload) => {
    log.debug('Received Push Notification', payload);
  });

  navigator?.serviceWorker?.addEventListener('message', (event) => {
    log.debug('Received message from service-worker', event);

    const { data } = event;
    if (data && data.messageType === 'notification-clicked') {
      const path = data.notification.click_action;
      if (path) {
        navigate(path);
      }
    }
  });
}
